<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :label="'全部 ' + '(' + (pageConfig.total || 0) + ')'" name="all"></el-tab-pane>
      <el-tab-pane :label="'草稿 ' + '(' + (allKinds.draftCount || 0) + ')'" name="0"></el-tab-pane>
      <el-tab-pane :label="'已确认 ' + '(' + (allKinds.markSureCount || 0) + ')'" name="10"></el-tab-pane>
      <el-tab-pane :label="'已完成 ' + '(' + (allKinds.doneCount || 0) + ')'" name="20"></el-tab-pane>
      <el-tab-pane :label="'已取消 ' + '(' + (allKinds.cancelCount || 0) + ')'" name="99"></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->
    <TwTable :searchData="searchData" :tableData="tableData" :tableConfig="tableConfig" :pageConfig="pageConfig"
      :filters="filters" :buttonList="buttonList" @resetBtn="resetBtn" @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick" @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox" @searchChange="searchChange" @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle" @handleSelsChange="handleSelsChange" @handleOperateEvent="handleOperateEvent">
      <template slot-scope="scope" slot="addServicesNo">
        <hoverCopy>
          <el-link slot="referenceChild" :underline="false" type="primary" @click.native="batchesDetail(scope.row)">{{
            scope.row.addServicesNo }}
          </el-link>
        </hoverCopy>
      </template>
      <template slot-scope="scope" slot="relationNumber">
        <hoverCopy>
          <span slot="referenceChild">{{ scope.row.relationNumber }}</span>
        </hoverCopy>
      </template>
      <template slot-scope="scope" slot="amount">
        <span>{{ scope.row.currency }} {{ scope.row.amount }}</span>
      </template>

      <template slot-scope="scope" slot="attachment">
        <div>
          <span v-if="scope.row.attachmentFiles > 0">
            <el-link
              style="margin-left: 5px"
              :underline="false"
              type="primary"
              @click.native="handleAttr(scope.row.tfAddServicesID,scope.row.addServicesNo)"
            >
              下载
            </el-link>
          </span>
          <br />
        </div>
      </template>

      <template slot-scope="scope" slot="picFile">
				<div>
					<span v-if="scope.row.donePics > 0">
						<el-link
							:underline="false"
							type="primary"
							@click.native="
								getReadyImages(scope.row.tfAddServicesID)
							"
						>
							预览
						</el-link>
					</span>
					<br />
				</div>
			</template>

    </TwTable>
    <LogDialog :logPageConfig="logPageConfig" :showLog="showLog" :requestData="{
      businessType: 39,
      businessCode: currentRow.addServicesNo,
    }" :requestApi="'/WareHouse/BusinessLogServices'" :requestMethod="'get'" v-if="showLog" @showDialog="showDialog">
    </LogDialog>
        <!-- 预览图片 -->

    <viewer :images="srcList" class="viewer" ref="viewer" @inited="inited">
      <img v-for="(src, index) in srcList" :src="src" :key="index" />
    </viewer>
    <!-- 新增、编辑、提交、标记、作废弹窗 -->
    <addServicesDalog ref="addServicesDalogRef" :addServicesType="addServicesType" @searchTable="initTable" />



    <!-- 上传图片 -->
    <el-dialog
      :visible.sync="importPicture"
      v-model="importPicture"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      title="上传操作图片"
      width="40%"
      style="text-align: center"
    >
      <el-form>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <el-form-item>
            <!-- 上传文件 -->
            <el-upload
              class="upload-demo"
              action="string"
              multiple
              accept=".jpg"
              :limit="10"
              drag
              :file-list="fileList"
              :before-remove="beforeRemove"
              :on-change="onChange"
              :http-request="httpRequest"
              :on-remove="onRemove"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">只能上传图片</div>
            </el-upload>
          </el-form-item>
        </el-row>
        <!-- :http-request="UploadBoxMarkExcel" -->
        <!-- 上传显示进度条 -->
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <!-- <el-form-item>
            <el-button type="primary" @click="handleDownload()"
              >下载打包数据</el-button
            >
          </el-form-item> -->
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="UploadBoxMarkExcel"
              >确定上传</el-button
            >
          </el-form-item>
        </el-row>
        <el-row type="flex" class="row-bg" style="justify-content: center">
          <div v-show="progressFlag" class="head-img" style="width: 150px">
            <el-progress
              :text-inside="true"
              :percentage="progressPercent"
              status="success"
            ></el-progress>
          </div>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
    
<script>
import {
  GetAddServicesTaskListAsync,
  AddServicesAsyncOut,
  EditServiceStatus,
  InsertAddServiceFile
} from "@/api/AddServices/index.js";
import {
   getUploadFileReviewImagesFileOut,
   getUploadFileInfoBySourceID,
  } from "@/api/api.js";
import axios from "axios";
import LogDialog from "../../components/TwTable/components/logDialog";
import { getCustomerList } from "@/api/common/common.js";
import TwTable from "../../components/TwTable/TwTable";
import hoverCopy from '../../components/hoverCopy.vue'
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { arrToJoin, toSelectOptions, getSearchDataIndex } from "util/util";
import addServicesDalog from "./components/addServicesDalog.vue";
export default {
  components: {
    TwTable,
    addServicesDalog,
    hoverCopy,
    LogDialog
  },
  mixins: [TwTable_mixins],
  data() {
    return {
      srcList: [],
      addServicesType: '',
      allKinds: {},
      fileList:[],
      uploadPic:'',
      progressFlag:false,
      importPicture: false,
      progressPercent:0,
      activeName: "all",
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showResetButton: true,
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "addServicesNo",
            label: "申请单号",
            slot: true,
            minWidth: "150",
          },
          {
            prop: "relationNumber",
            label: "关联单号",
            minWidth: "160",
            slot: true,
          },
          {
            prop: "warehouseName",
            label: "仓库",
            minWidth: "120",
          },
          {
            prop: "boxInfo",
            label: "数量",
            minWidth: "160",
          },
          {
            prop: "customName",
            label: "客户货主",
            minWidth: "120",
          },
          
          {
            prop: "feeTypeName",
            label: "增值服务类型",
            minWidth: "150",
          },
           {
            prop: "attachment",
            label: "附件",
            slot: true,
            minWidth: "100",
          },
          {
            prop: "servicesRemark",
            label: "操作说明",
            minWidth: "250",
          },
          {
            prop: "ecTimeText",
            label: "期望时间",
            minWidth: "150",
          },
          {
            prop: "serviceStatusText",
            label: "状态",
            minWidth: "80",
          },
          {
            prop: "doneQty",
            label: "实际操作数量",
            minWidth: "130",
          },
          {
            prop: "doneUser",
            label: "操作人",
            minWidth: "150",
          },
          {
            prop: "doneTimeText",
            label: "操作时间",
            minWidth: "150",
          },
          {
							prop: "picFile",
							label: "图片",
							slot: true,
							minWidth: "120",
						},
          {
            prop: "doneRemark",
            label: "仓库备注",
            minWidth: "150",
          },
          {
            prop: "createTimeText",
            label: "创建时间",
            minWidth: "150",
          },
          {
            prop: "amount",
            label: "费用",
            minWidth: "80",
            slot: true,
          },
        ],
      },
      searchData: {
        //搜索列配置
        search: [
          {
            type: "input",
            key: "key",
            label: "单据号",
            placeholder: "申请单号/关联单号",
            clearable: true,
          },
          {
            type: "select",
            key: "WarehouseIds",
            label: "仓库",
            multiple: true,
            clearable: true,
            options: [],
          },
          {
            type: "select",
            key: "OrgIDs",
            label: "客户",
            multiple: true,
            clearable: true,
            options: [],
          },
          {
            type: "select",
            key: "status",
            label: "状态",
            multiple: true,
            clearable: true,
            options: [
              {
                label: "草稿",
                value: 0,
              },
              {
                label: "已确认",
                value: 10,
              },
              {
                label: "已完成",
                value: 20,
              },
              {
                label: "已取消",
                value: 99,
              },
            ],
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      //-------------
    };
  },
  methods: {
    //预览图片
			getReadyImages(id) {

        let data = {
                sourceID: id,
                sourceType: 43
            }
            const loading = this.$loading({
                lock: true,
                text: "图片加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.5)",
            });
            getUploadFileInfoBySourceID(data).then((res) => {
                console.log(res);
					loading.close();
					if (res.data.status === 200 && res.data.success) {
						const { response } = res.data;
						response.forEach((item, i) => {
							response[i] = `data:image/png;base64,${item}`;
						});
						this.srcList = response;
						this.$viewer.view(0);
						this.$viewer.show();
					} else {
						this.$message({
							message: "加载失败！",
							type: "error",
						});
					}
            })
			},

      inited(viewer) {
      this.$viewer = viewer;
    },
    // 新增增值服务
    addServices() {
      this.addServicesType = 'homeAdd'
      this.$nextTick(() => {
        this.$refs.addServicesDalogRef.showDalog();
      })
    },
    onChange(file, fileList) {
      this.fileList = fileList;
      console.log(this.fileList);
    },
    httpRequest(param) {
      // this.fileList.push(param.file)
      console.log(param);
    },
    //移除图片
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onRemove(file, fileList) {
      this.fileList = fileList;
    },
    addDoneImages() {
      if(this.selectRows.rows.length !== 1)
      {
         this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }
      if(this.selectRows.rows[0].serviceStatus!==20)
      {
         this.$message({
          message: "只能操作已完成的数据",
          type: "error",
        });
        return;
      }
      this.fileList = [];
      this.uploadPic='';
      this.importPicture = true;
    },

    //上传操作图片
    UploadBoxMarkExcel(file) {
      let para = new FormData();
      this.uploadPic='';
      for (var i = 0; i < this.fileList.length; i++) {
        console.log(this.fileList[i].size);
        if (this.fileList[i].size > 10 * 1024 * 1024) {
          this.$message({
            message:
              "文件" + this.fileList[i].name + "不能大于10M，请选择小的文件",
            type: "error",
          });
          return false; //必须返回false
        }
        para.append("file", this.fileList[i].raw); //此处一定是append file.raw 上传文件只需维护fileList file.raw.name要加上
        para.append("fileName", this.fileList[i].name);
        this.uploadPic=this.uploadPic+this.fileList[i].name+',';
      }
      this.uploadPic.substring(0, this.uploadPic.length - 1);
      let row = this.selectRows.rows[0];
      console.log(para);
      //para.append("file", param.file);
      this.progressFlag = true;
      axios({
        url:InsertAddServiceFile+"?tfAddServicesID="+row.tfAddServicesID,
        method: "post",
        data: para,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          //进度条
          this.progressPercent =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
        },
      })
        .then((res) => {
          if (res.data.success) {
            this.importPicture = false;
            //param.onError(); // 上传成功的文件会显示绿色的对勾
            console.info(res.data.response.join(","));
            this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "上传失败",
              type: "error",
            });
            //param.onError();
          }
          this.progressFlag = false;
          this.progressPercent = 0;
        })
        .catch((error) => {
          this.progressFlag = false;
          this.progressPercent = 0;
          this.$message({
            message: "文件导入失败，请重试",
            type: "error",
          });
          //param.onError();
        });
    },
    handleAttr(id,addNumber) {
      const para = {
        sourceID: id,
        sourceType:42,
        title:"附加服务"+addNumber
      };

      const loading = this.$loading({
        lock: true,
        text: "下载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios
        .get(getUploadFileReviewImagesFileOut, {
          params: para,
        })
        .then((res) => {
          loading.close();
          if (res.data.success) {
            var data = res.data.response;
            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    handleClick() {
      this.$set(this.filters, 'status', isNaN(Number(this.activeName)) ? undefined : [Number(this.activeName)])
      this.initTable()
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    batchesDetail(rowData) {
      this.addServicesType = 'view'
      this.$nextTick(() => {
        this.$refs.addServicesDalogRef.showDalog(rowData)
      })
    },
    //查询列表
    initTable() {
      const { WarehouseIds, OrgIDs, status } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize || 50,
        ...this.filters,
        WarehouseIds: arrToJoin(WarehouseIds),
        OrgIDs: arrToJoin(OrgIDs),
        status: arrToJoin(status)
      };
      console.info(new Date().toLocaleString());
      this.getTableData(GetAddServicesTaskListAsync, para).then((res) => {
        if (res.success && res.response.pageData && res.response.pageData.length) {
          let { draftCount, markSureCount, doneCount, cancelCount } = res.response.pageData[0]
          this.allKinds = {
            draftCount, markSureCount, doneCount, cancelCount
          }
        } else {
          this.allKinds = {}
        }
      });
    },
    // 编辑
    edit() {
      this.validSelectRows([0], 'serviceStatus', '只有草稿状态可以修改').then((rowData) => {
        this.addServicesType = 'edit'
        this.$nextTick(() => {
          this.$refs.addServicesDalogRef.showDalog(rowData)
        })
      })
    },
    getButtonIndex(fnName) {
      let fnIndex = 0
      this.buttonList.forEach((item, index) => {
        if (item.func == fnName) {
          fnIndex = index
          return
        }
      })
      return fnIndex
    },
    // 提交
    submit(voidFn) {
      this.validSelectRows([0], 'serviceStatus', voidFn ? '只有草稿状态可以作废' : '只有草稿状态可以提交').then((rowData) => {
        this.$confirm(voidFn ? '确认作废吗？' : "确认提交吗？", "提示", {})
          .then(() => {
            this.$set(
              this.buttonList[this.getButtonIndex(voidFn ? 'voidFn' : 'submit')],
              "loading",
              true
            )
            let para = {
              addServicesID: rowData.tfAddServicesID,
              serviceStatus: voidFn ? 99 : 10,
            }
            EditServiceStatus(para).then((res) => {
              this.$set(
                this.buttonList[this.getButtonIndex(voidFn ? 'voidFn' : 'submit')],
                "loading",
                false
              )
              if (res.data.success) {
                this.$message({
                  message: res.data.msg || "操作成功",
                  type: "success",
                });
                this.initTable()
              } else {
                this.$message({
                  message: res.data.msg || "操作失败",
                  type: "error",
                });
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      })
    },
    // 标记完成
    markComplete() {
      this.validSelectRows([10], 'serviceStatus', '只有已确认状态可以标记完成').then((rowData) => {
        this.addServicesType = 'markComplete'
        console.info(rowData);
        this.$nextTick(() => {
          this.$refs.addServicesDalogRef.showDalog(rowData)
        })
      })
    },
    //  作废
    voidFn() {
      this.submit('voidFn')
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;
      let AddServicesIDs
      if (row && row.length) {
        AddServicesIDs = row.map((item) => item.tfAddServicesID).join(",");
      }
      let params = {
        ...this.searchParams,
        AddServicesIDs,
        page: 1,
        pageSize: 60001,
      };
      this.exportFile(AddServicesAsyncOut, params);
    },

    // 调账
    ChangeBill() {
      this.$refs.accountAdjustmentDalogRef.showDalog();
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    // 获取搜索栏下拉框数据
    initDropList() {
      // 设置仓库下拉
      let user = JSON.parse(window.localStorage.user);
      this.setSearchOptions(
        "search",
        "WarehouseIds",
        toSelectOptions(user.warehouseList, "warehouseId", "warehouseName")
      );

      // 设置客户下拉
      getCustomerList({}).then((res) => {
        this.setSearchOptions(
          "search",
          "OrgIDs",
          toSelectOptions(res.data.response, "id", "customName")
        );
      });
    },
    resetBtn() {
      this.filters = {};
    },
  },

  mounted() {
    // 获取按钮配置
    this.getMixinsButtonList();
    // 获取搜索栏下拉框数据
    this.initDropList();
  },
};
</script>
  <style scoped lang="less">
.viewer-list > li {
  width: 80px;
}
.viewer {
  display: none;
}
</style>